var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":require('@/assets/no-data.svg'),"alt":""}})]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('無法讀取資料'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }